import React, { useCallback, useState } from 'react';
import { __ } from '@wordpress/i18n';

const STORAGE_KEY = 'sb.commCenter.walkthroughDismissed';

const readDismissed = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

/**
 * Onboarding box shown only the first time a user lands on the app. Dismissing
 * it is remembered locally, so it never comes back for that browser.
 */
const WalkthroughBox = () => {
    const [dismissed, setDismissed] = useState(readDismissed);

    const dismiss = useCallback(() => {
        setDismissed(true);

        try {
            window.localStorage.setItem(STORAGE_KEY, '1');
        } catch (e) {
            // Private mode / blocked storage: the box simply reappears next time.
        }
    }, []);

    if (dismissed) return null;

    return (
        <section className="commWalkthrough">
            <h4 className="commWalkthrough__title">{__('Cosa trovi qui?', 'soundbetween')}</h4>
            <p className="commWalkthrough__text">
                {__('Gli aggiornamenti di oggi da tutti i tuoi progetti. Gli elementi non letti hanno un punto blu. Trascina verso sinistra per archiviare; apri la vista archivio per rivederli.', 'soundbetween')}
            </p>
            <button type="button" className="commWalkthrough__dismiss" onClick={dismiss}>
                {__('Ho capito', 'soundbetween')}
            </button>
        </section>
    )
}

export default WalkthroughBox;
